module.exports = "\n<router-outlet></router-outlet>\n<app-progress-bar></app-progress-bar>"